import { Skeleton } from "@shc/ui";

const News2knowSearchSkeleton = () => (
  <>
  {/* desktop */}
  <div className="hidden xl:flex flex-col gap-8">
    <Skeleton variant="rounded" height={24} width={235} className="block" />

    <Skeleton variant="rounded" height={1} width="100%" className="block" />
    {[...Array(10)].map((_, i) => (
      <div key={i}>
        <div className='flex flex-col gap-4'>
          <Skeleton variant="rounded" height={16} width={226} className="block" />
          <Skeleton variant="rounded" height={24} width={350} className="block" />
          <Skeleton variant="rounded" height={16} width="100%" className="block" />
          <Skeleton variant="rounded" height={16} width={598} className="block" />
        </div>
        <Skeleton variant="rounded" height={1} width="100%" className="block" />
      </div>
    ))}
  </div>
  
  {/* mobile */}
  <div className="xl:hidden flex flex-col gap-8" >
    <Skeleton variant="rounded" height={24} width={235} className="block" />

    <Skeleton variant="rounded" height={1} width="100%" className="block" />
    {[...Array(10)].map((_, i) => (
      <div key={i}>
        <div className='flex flex-col gap-4'>
          <Skeleton variant="rounded" height={16} width={160} className="block" />
          <Skeleton variant="rounded" height={24} width={160} className="block" />
          <Skeleton variant="rounded" height={16} width="100%" className= "block" />
          <Skeleton variant="rounded" height={16} width="100%" className="block" />
        </div>
        <Skeleton variant="rounded" height={1} width="100%" className="block" />
      </div>
    ))}
  </div> 
  </>
)

export default News2knowSearchSkeleton